<template>
  <div class="footerWrapper">
    <div class="footerLeftWrapper">
      <v-btn small class="footer-paymentBtn" depressed @click="showPriceModal">{{ $t("footer.getPlan") }}</v-btn>
      <v-menu class="footer-left" v-if="customerBalance != null" :position-y="cardOffsetY" :position-x="cardOffsetX"
        absolute offset-y open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <div class="usageButton" v-bind="attrs" v-on="on">
            <v-progress-circular :rotate="-90" :size="36" :width="3" :value="getLeftPercent" style="margin:0px 10px"
              :color="getLeftPercent < 15 ? '#D23636' : '#777FF6'">
              <div style="font-size:11px">
                {{ getLeftPercent }}%
              </div>
            </v-progress-circular>
            {{ $t("footer.remainingPlan") }}
            <ArrowUpIcon color="#777FF6" />
          </div>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-title>
              <div class="usageInfoCard">
                <p style="font-weight:bold">{{ $t("footer.usageInfo") }}</p>
                <!-- <p>
                  {{ $t("footer.totalPages") }} ~{{
                      Math.floor(customerBalance.TotalBalance / 3750)
                  }}
                </p> -->
                <p>
                  {{ $t("footer.totalCharacters") }} ~{{
                      isTooLargeNumber(Math.floor(customerBalance.TotalBalance))
                  }}
                </p>
                <p>
                  {{ $t("footer.leftCharacters") }} ~{{
                      isTooLargeNumber(
                        Math.floor(
                          customerBalance.TotalBalance - customerBalance.TotalUsed
                        )
                      )
                  }}
                </p>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="d-flex align-center">
        <router-link to="/history" class="text paymentStyle">{{
            $t("footer.paymentHistory")
        }}</router-link>
      </div>
    </div>
    <div class="footerRightWrapper">
      <span class="company">© Chimege systems</span>
    </div>
    <v-dialog v-if="isPriceModal" v-model="isPriceModal" max-width="770" max-height="620">
      <div class="mainTitle">
        <v-card class="mainItem" v-for="(item, i) in itemPrice" :key="i" style="border-radius:20px;  padding: 10px 0"
          elevation="1">
          <div class="titleBar">
            <div class="titleModal">{{ item.character }}</div>
          </div>
          <div class="descriptionInfo" v-for="(item, i) in item.description" :key="i">
            <span>
              <v-icon class="icon">mdi-check</v-icon>
            </span>
            <span class="descriptionItem">{{ $t(item) }}</span>
          </div>
          <div class="d-flex mb-4 justify-center">
            <span class="price">{{ item.price }}</span>
            <span class="currency">₮</span>
          </div>
          <div v-if="customerPlan && tablePrice">
            <v-card-actions class="justify-end">
              <v-btn class="btnStyle" @click="buyPage(i)" :disabled="buyLoading == i">
                <v-progress-circular v-if="buyLoading == i" :size="25" :width="3" color="#ffffff" indeterminate>
                </v-progress-circular>
                <span v-else style="color:#ffffff">{{
                    $t("footer.getPlanBtn")
                }}</span>
              </v-btn>
            </v-card-actions>
          </div>
          <div v-else class="priceLoaderWrapper">
            <v-progress-circular :size="40" :width="3" color="#787ff7" indeterminate></v-progress-circular>
          </div>
        </v-card>
      </div>
      <!-- </div> -->
    </v-dialog>
  </div>
</template>
<script>
import ArrowUpIcon from "../components/icons/ArrowUpIcon";
import axios from "axios";
import { mapActions, mapState } from "vuex";
export default {
  name: "Footer",
  data: () => ({
    focus: "",
    cardOffsetX: 0,
    cardOffsetY: 0,
    isPriceModal: false,
    quantity: 1,
    modalWrapLoading: false,
    unitPrice: 0,
    totalPrice: 0,
    buyLoading: null,
    itemPrice: [{ character: "500 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "1,000" },
    { character: "5,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "5,000" },
    { character: "12,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "10,000" },
    { character: "25,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "20,000" },
    { character: "200,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "100,000" },
    { character: "2,000,000 тэмдэгт", description: ["plan.planWork1", "plan.planWork2", "plan.planWork3", "plan.planWork4", "plan.planWork5"], price: "800,000" }]
  }),
  components: {
    ArrowUpIcon,
  },
  computed: {
    ...mapState([
      "user",
      "customerPlan",
      "tablePrice",
      "customerBalance",
      "walletBalance",
    ]),
    getToken: function () {
      return this.$cookie.get("token");
    },
    getLeftPercent: function () {
      if (this.customerBalance.TotalBalance == 0) {
        return 0;
      } else {
        return (
          100 -
          (
            (this.customerBalance.TotalUsed /
              this.customerBalance.TotalBalance) *
            100
          ).toFixed(0)
        );
      }
    },
  },
  watch: {
    quantity: function () {
      if (parseInt(this.quantity)) {
        let table = this.tablePrice[this.customerPlan.PlanID];
        for (let i = table.length - 1; i >= 0; i--) {
          if (table[i].PageCount <= this.quantity) {
            this.unitPrice = table[i].PagePrice;
            break;
          }
        }
        this.totalPrice = this.unitPrice * this.quantity;
      } else {
        this.unitPrice = this.tablePrice[this.customerPlan.PlanID][0].PagePrice;
        this.totalPrice = 0;
      }
    },
  },
  methods: {
    ...mapActions([
      "updateUser",
      "initCustomerPlan",
      "initAllPlan",
      "initTablePrice",
      "updateBalance",
      "checkError",
      "updateWalletBalance",

    ]),
    isTooLargeNumber(number) {
      if (number > 1000000) {
        let mNumber = number / 1000000;
        return Math.floor(mNumber) + "сая";
      } else return Math.floor(number);
    },
    getFormatNumber(number) {
      return Intl.NumberFormat().format(number);
    },
    showPriceModal() {
      if (this.tablePrice && this.customerPlan) {
        this.unitPrice = this.tablePrice[this.customerPlan.PlanID][0].PagePrice;
        this.totalPrice = this.quantity * this.unitPrice;
      } else {
        if (this.tablePrice == null) {
          console.log("update");
        } else if (this.customerPlan == null) {
          console.log("update");
        } else {
          console.log("update");
        }
      }

      this.isPriceModal = true;
    },
    closePriceModal() {
      this.quantity = 1;
      this.isPriceModal = false;
      localStorage.setItem("isPriceModel" , false)
    },
    buyPage(value) {
      this.buyLoading = value;
      let urlToJump = "";
      const headers = {
        token: this.getToken,
      };
      axios
        .put(`${process.env.VUE_APP_BASE_URL}/buy`, value+1, {
          headers,
        })
        .then((response) => {
          if (response.status == 200) {
            const headers = { token: this.getToken };
            urlToJump = response.data.data.Url;
            axios
              .get(`${process.env.VUE_APP_BASE_URL}/getWalletBalance`, {
                headers,
              })
              .then((response) => {
                this.$store.state["walletBalance"] = response.data.data;
                if (urlToJump.includes("/orders")) {
                  window.location.href =
                    urlToJump +
                    "?totalPrice=" +
                    this.itemPrice[value].price +
                    "&quantity=" +
                    this.itemPrice[value].character +
                    "&userBalance=" +
                    this.walletBalance;
                } else {
                  window.location.href = urlToJump;
                }
              })
              .catch((error) => {
                if (
                  error.response.status === 403 ||
                  error.response.status === 401
                ) {
                  this.$cookie.delete("token");
                  window.location.href =
                    process.env.VUE_APP_BASE_URL + "/login";
                }
              });
          }

          this.isPriceModal = false;
          localStorage.setItem("isPriceModel" , false)
          this.buyLoading = null;
          return;
        })
        .catch((error) => {
          this.isPriceModal = false;
          localStorage.setItem("isPriceModel" , false)
          this.buyLoading = null,
            this.checkError(error);
        });
    },
  },
  mounted() {
    this.cardOffsetX = window.screen.width > 600 ? 80 : 10;
    this.cardOffsetY = window.screen.height - 258;
    var openPriceModel = localStorage.getItem("isPriceModel")
    if (openPriceModel !== "") {
     if( openPriceModel === "true") {
        this.isPriceModal = true
      }
    }
    localStorage.removeItem("isPriceModel")
  },
};
</script>
<style scoped>
.footerWrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  background-color: white;
  border-top: 1px solid #e5e5e5;
}

.footerLeftWrapper {
  padding-left: 13px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}


.currency {
  font-weight: 600;
  font-size: 16px;
  color: #2c3e50;
}

.usageInfoCard {
  padding-top: 16px;
}

.privacyLink,
.paymentStyle {
  color: #231f20 !important;
  font-size: 14px;
  text-decoration: none;
  font-weight: 500;
}

.downloadAppBtn {
  height: 34px !important;
  color: #ffffff !important;
  background-color: #777ff6 !important;
  text-transform: initial !important;
  margin-right: 13px !important;
}

.version {
  margin-left: 20px;
  font-size: 14px;
  color: #98a7ad;
}

.company {
  font-size: 14px;
  color: #767676;
}

.footerRightWrapper {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  margin-right: 13px;
}

@media screen and (max-width: 768px) {
  .footerWrapper {
    justify-content: center;
  }

  .usageButton,
  .paymentStyle {
    display: none;
  }

  .footerRightWrapper {
    justify-content: center;
  }
}

@media screen and (max-width: 599px) {
  .privacyLink {
    display: none;
  }
}

.footer-paymentBtn {
  font-weight: 500;
  color: #ffffff !important;
  background-color: #777ff6 !important;
  text-transform: initial !important;
  margin-right: 4px;
}

.dialogTextStyle {
  color: #2c3e50;
  /* color: red; */
  font-size: 14px;
}

.titleBar {
  border-bottom: 1px solid #e8e8e8;
  height: 35px !important;

  align-items: center;
  margin: 0 7px;
}

.titleModal {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #787ff7;
  text-align: center;
  margin-top: 10px;
}

.price {
  font-feature-settings: "tnum";
  font-variant: tabular-nums;
  font-family: "Roboto", sans-serif;
  font-size: 25px;
  font-weight: 500;
  line-height: 26px;
  color: black;
  text-align: center;
  padding-bottom: 10px;

}

.descriptionItem {
  color: #2c3e50a6;
  font-weight: 500;
  line-height: 1.5;
  font-size: 14px;
  text-align: left;
}

.icon {
  color: #787ff7;
  margin-right: 20px;
}

.descriptionInfo {
  display: flex;
  align-items: left;
}

.btnStyle {
  background-color: #787ff7 !important;
  color: #ffffff;
  /* box-shadow: 0 3px 5px 0 rgba(50, 50, 247, 0.3); */
  padding: 8px 20px !important;
  outline: none;
  font-size: 16px;
  letter-spacing: 0.5px;
  transition: all 0.3s;
  font-weight: 500;
  border-radius: 6px;
  text-transform: capitalize;
  width: 100%;
}

.priceInfoWrapper {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: #f6f7f9;
}

.priceItemWrapper {
  display: flex;
  padding: 13px;
  border-bottom: 1px solid #f1f1f1;
  justify-content: space-between;
  align-items: center;
}

.mainTitle {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  background-color: white;
}

.mainItem {
  flex: 30%;
  margin: 10px;
}

.descriptionInfo {
  margin: 10px;
}

.priceItemWrapper:nth-last-child(1) {
  border-bottom: none;
}

.pricing-inputWrapper {
  display: flex;
  position: relative;
  align-items: center;
}

.pricing-inputWrapper input[type="number"] {
  width: 50px !important;
  height: 30px !important;
  margin: 0 4px;
  /* padding-left: 8px; */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  text-align: center;
  line-height: 16px;
  transition: 0.4s ease-out;
}

.pricing-inputWrapper input[type="number"]:focus {
  border: 1px solid #777ff6 !important;
  outline: none;
}

.pricing-inputWrapper input[type="number"]:hover {
  border: 1px solid #777ff6 !important;
  transition: 0.4s ease-out;
  outline: none;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.pm-button {
  display: flex;
  text-align: center !important;
  min-width: 20px !important;
  width: 20px !important;
  height: 20px !important;
  padding: 0 !important;
  color: #767676 !important;
  background-color: #ffffff !important;
  text-transform: initial !important;
  box-shadow: none;
  outline: none;
  border: 1px solid #e5e5e5;
}

.priceLoaderWrapper {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 242px;
}
</style>
